import client from './client';

const Decisions = {
  getDecisions(anketId) {
    return client.get(`/ankets/${anketId}/decisions`);
  },

  getDecision(anketId, decisionId) {
    return client.get(`/ankets/${anketId}/decisions/${decisionId}`);
  },

  updateDecision(anketId, decisionId, data) {
    return client.put(`/ankets/${anketId}/decisions/${decisionId}`, data);
  },
};

export default Decisions;
